<template>
    <v-card v-if="model.id" class="elevation-2">
      <v-card-title class="text-h5">
        <h2 class="font-weight-bold text--primary"> Contrato </h2>
      </v-card-title>
      <v-card-subtitle class="title text--black font-weight-black font-weight-bold">
          {{`[ ${model.folio} ]`}}
      </v-card-subtitle>
      <v-tabs v-model="tab" background-color="primary" align-with-title dark>
        <v-tabs-slider color="white"></v-tabs-slider>
        <v-tab href="#General">General</v-tab>
        <v-tab href="#Facturas">Facturas</v-tab>
        <!-- <v-tab href="#two" @click="viewEquipo()">Equipo Computo</v-tab> -->
        <v-tab href="#Movimientos" @click="viewMovs(model.folio)">Bitácora de Movimientos</v-tab>
      </v-tabs>
      <v-tabs-items v-model="tab">
          <!-- General -->
          <v-tab-item value="General">
            <v-card width="auto" outlined>
                <v-card-text>

<v-row dense>
    <v-col cols="12" sm="12" md="12">
        <label class="font-weight-bold subtitle-1 text--primary">Proveedores: </label>
        <p v-for="(p) in model.proveedores" :key="p.id" class="font-weight-bold text--secondary">
            {{p.rfc}} - {{p.nombre}}
        </p>
    </v-col>

    <v-col cols="12" sm="12" md="6">
        <label class="font-weight-bold subtitle-1 text--primary">Fecha inicio: </label>
        <p class="font-weight-bold text--secondary">
            {{model.caracteristicas.fInicio}}
        </p>
    </v-col>

    <v-col cols="12" sm="12" md="6">
        <label class="font-weight-bold subtitle-1 text--primary">Fecha finalizacion: </label>
        <p class="font-weight-bold text--secondary">
            {{model.caracteristicas.fFinalizacion}}
        </p>
    </v-col>

    <v-col cols="12" sm="12" md="12">
        <label class="font-weight-bold subtitle-1 text--primary">Contrato: </label>
        <p class="font-weight-bold text--secondary">
            {{model.caracteristicas.contrato.toUpperCase()}}
        </p>
    </v-col>

    <v-col cols="12" sm="12" md="12">
        <label class="font-weight-bold subtitle-1 text--primary">Concurso | No. Invitación (I.A.) | CompraNet | No. Licitación (L.A.): </label>
        <p class="font-weight-bold text--secondary">
            {{model.caracteristicas.cicl}}
        </p>
    </v-col>

    <v-col cols="12" sm="12" md="12">
        <label class="font-weight-bold subtitle-1 text--primary">Objeto del contrato: </label>
        <p class="font-weight-bold text--secondary">
            {{model.caracteristicas.objeto_contrato}}
        </p>
    </v-col>

    <v-col cols="12" sm="12" md="6">
        <label class="font-weight-bold subtitle-1 text--primary">Fuente de financiamiento: </label>
        <p class="font-weight-bold text--secondary" v-if="model.fuente_financiamiento">
            {{ `${model.fuente_financiamiento.nombre} - ${model.fuente_financiamiento.tipo.toUpperCase()}` }}
        </p>
    </v-col>

    <v-col cols="12" sm="12" md="4">
        <label class="font-weight-bold subtitle-1 text--primary">Area Solicitante: </label>
        <p class="font-weight-bold text--secondary">
            {{model.area_solicitante.nombre.toUpperCase()}}
        </p>
    </v-col>

    <v-col cols="12" sm="12" md="4">
        <label class="font-weight-bold subtitle-1 text--primary">Área contratante: </label>
        <p class="font-weight-bold text--secondary">
            {{model.area_contratante.nombre.toUpperCase()}}
        </p>
    </v-col>

    <v-col cols="12" sm="12" md="4">
        <label class="font-weight-bold subtitle-1 text--primary">Área responsable de su ejecución: </label>
        <p class="font-weight-bold text--secondary">
            {{model.area_responsable.nombre.toUpperCase()}}
        </p>
    </v-col>

    <v-col cols="12" sm="12" md="4">
        <label class="font-weight-bold subtitle-1 text--primary">Fecha de publicación de la convocatoria u Oficio ITP: </label>
        <p class="font-weight-bold text--secondary">
            {{model.caracteristicas.fPublicacion}}
        </p>
    </v-col>

    <v-col cols="12" sm="12" md="4">
        <label class="font-weight-bold subtitle-1 text--primary">Fecha de Junta de Aclaraciones: </label>
        <p class="font-weight-bold text--secondary">
            {{model.caracteristicas.fJuntaAclaracion}}
        </p>
    </v-col>

    <v-col cols="12" sm="12" md="4">
        <label class="font-weight-bold subtitle-1 text--primary"># part. Junta aclaraciones: </label>
        <p class="font-weight-bold text--secondary">
            {{model.caracteristicas.num_parte_junta}}
        </p>
    </v-col>

    <v-col cols="12" sm="12" md="4">
        <label class="font-weight-bold subtitle-1 text--primary">Fecha de apertura (entrega de propuestas): </label>
        <p class="font-weight-bold text--secondary">
            {{model.caracteristicas.fApertura}}
        </p>
    </v-col>

    <v-col cols="12" sm="12" md="4">
        <label class="font-weight-bold subtitle-1 text--primary"># part. de apertura (ent. de prop.): </label>
        <p class="font-weight-bold text--secondary">
            {{model.caracteristicas.num_apertura}}
        </p>
    </v-col>

    <v-col cols="12" sm="12" md="4">
        <label class="font-weight-bold subtitle-1 text--primary">Fecha de Fallo: </label>
        <p class="font-weight-bold text--secondary">
            {{model.caracteristicas.fFallo}}
        </p>
    </v-col>

    <v-col cols="12" sm="12" md="4">
        <label class="font-weight-bold subtitle-1 text--primary">Monto autorizado sin IVA (Resp. Sol. Suf.): </label>
        <p class="font-weight-bold text--secondary">
            $ {{model.caracteristicas.monto_autorizado_sin_iva}}
        </p>
    </v-col>

    <v-col cols="12" sm="12" md="4">
        <label class="font-weight-bold subtitle-1 text--primary">Monto autorizado con IVA (Resp. Sol. Suf.): </label>
        <p class="font-weight-bold text--secondary">
            $ {{model.caracteristicas.monto_autorizado_con_iva}}
        </p>
    </v-col>

    <v-col cols="12" sm="12" md="4">
        <label class="font-weight-bold subtitle-1 text--primary">Monto máximo sin IVA: </label>
        <p class="font-weight-bold text--secondary">
            $ {{model.caracteristicas.monto_maximo_sin_iva}}
        </p>
    </v-col>

    <v-col cols="12" sm="12" md="4">
        <label class="font-weight-bold subtitle-1 text--primary">Monto máximo con IVA: </label>
        <p class="font-weight-bold text--secondary">
            $ {{model.caracteristicas.monto_maximo_con_iva}}
        </p>
    </v-col>

    <v-col cols="12" sm="12" md="4">
        <label class="font-weight-bold subtitle-1 text--primary">Importe del contrato (Con IVA): </label>
        <p class="font-weight-bold text--secondary">
            $ {{model.caracteristicas.importe_con_iva}}
        </p>
    </v-col>

    <v-col cols="12" sm="12" md="4">
        <label class="font-weight-bold subtitle-1 text--primary">Tipo de procedimiento: </label>
        <p class="font-weight-bold text--secondary">
            {{model.tipo_procedimiento.nombre}}
        </p>
    </v-col>

    <v-col cols="12" sm="12" md="12">
        <label class="font-weight-bold subtitle-1 text--primary">Tipo de contrataciónes: </label>
        <p v-for="(p) in model.TipoContrataciones" :key="p.id" class="font-weight-bold text--secondary">
            {{p.nombre}}
        </p>
    </v-col>

    <v-col cols="12" sm="12" md="4">
        <label class="font-weight-bold subtitle-1 text--primary">No. sesión en la que se dictaminó procedente la EXCEPCIÓN: </label>
        <p class="font-weight-bold text--secondary">
            {{model.caracteristicas.num_sesion}}
        </p>
    </v-col>

    <v-col cols="12" sm="12" md="4">
        <label class="font-weight-bold subtitle-1 text--primary">Fecha de la sesión (Exepción): </label>
        <p class="font-weight-bold text--secondary">
            {{model.caracteristicas.fSesion}}
        </p>
    </v-col>

    <v-col cols="12" sm="12" md="12">
        <label class="font-weight-bold subtitle-1 text--primary">Expediente (Identificación del procedimiento): </label>
        <p class="font-weight-bold text--secondary">
            {{model.caracteristicas.expediente}}
        </p>
    </v-col>

    <v-col cols="12" sm="12" md="12">
        <label class="font-weight-bold subtitle-1 text--primary">Observaciones: </label>
        <p class="font-weight-bold text--secondary">
            {{model.caracteristicas.observaciones}}
        </p>
    </v-col>

</v-row>
</v-card-text>
          </v-card>
          </v-tab-item>
          <!-- Inventario -->
          <v-tab-item value="two">
            <v-card width="auto" outlined>
              <v-card-text>
              </v-card-text>
            </v-card>
          </v-tab-item>
        <!-- Facturas -->
        <v-tab-item value="Facturas">
            <v-data-table
                :headers="headers"
                :items="seguimientos"
                :items-per-page="5"
                class="elevation-1"
            >
            <template v-slot:item.factura.descripcion.fFactura="{ item }">
                <span>{{ formatDate(item) }}</span>
            </template>
            <template v-slot:item.factura.descripcion.total_con_impuestos="{ item }">
                $<span>{{ new Intl.NumberFormat('es-MX').format(item.factura.descripcion.total_con_impuestos)}}</span>
            </template>
        </v-data-table>
          </v-tab-item>
          <!-- Bitacorra -->
          <v-tab-item value="Movimientos">
            <v-card width="auto" outlined>
              <v-card-text>
                <v-row dense>
                  <v-col v-if="showMovs" cols="12">
                    <ViewMovementsField :itemAction="movs" />
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-tab-item>
      </v-tabs-items>
    </v-card>
    <!--
    <v-card v-if="model.id" class="elevation-2">
      <v-card-text>
      </v-card-text>
    </v-card>
  -->
  </template>
<script>
import { mapGetters, mapMutations } from 'vuex'
import ViewMovementsField from '@/components/fields/specific/ViewMovementsField'
export default {
  props: ['model'],
  data: () => ({
    tab: 0,
    movs: {
      field: 'showMovsDataServer',
      name: '',
      nameid: 'movimientos',
      url: '/procesos/movimientos',
      default: '/procesos/movimientos',
      hidden: true,
      cols: 12
    },
    showMovs: false,
    showEq: false,
    itemInsumos: {},
    headers: [
      { text: 'Folio fiscal', value: 'factura.descripcion.folio_fiscal' },
      { text: 'Proveedor', value: 'factura.proveedor.nombre' },
      { text: 'Tipo', value: 'factura.tipo_contratacion.nombre' },
      { text: 'N° Partidas', value: 'factura.NumPatidas' },
      { text: 'Fecha', value: 'factura.descripcion.fFactura' },
      { text: 'Total', value: 'factura.descripcion.total_con_impuestos' }
    ],
    seguimientos: []
  }),
  components: {
    ViewMovementsField
  },
  methods: {
    ...mapMutations(['SHOW_DIALOG_MAIN']),
    formatDate (item) {
      const today = new Date()
      const yyyy = today.getFullYear()
      let mm = today.getMonth() + 1
      let dd = today.getDate()
      if (dd < 10) dd = '0' + dd
      if (mm < 10) mm = '0' + mm

      return `${dd}-${mm}-${yyyy}`
    },
    successAction (item) {
      this[item.action](item)
    },
    addInsumosView (item) {
      this.itemInsumos = {}
      this.itemInsumos = Object.assign({}, item.item)
      this.SHOW_DIALOG_MAIN({ type: 'addInsumos', with: 900, title: 'Agregar Insumos' })
    },
    returnedInsumosView (item) {},
    viewMovs (folio) {
      this.showMovs = false
      this.movs.url = `${this.movs.default}?folio=${folio}&mov=all`
      setTimeout(() => { this.showMovs = true }, 200)
    },
    viewEquipo () {
    /*
        if (this.model.descripcion.equipo) return
        this.showEq = false
        const router = this.get_urls['catalogo.familias-caracteristica.formulario']
        this.urlGetServiceActionTwo({ url: router, params: `/${this.model.descripcion.inventario.caracteristicas.familia_id}`, replace: '/{id}' })
        setTimeout(() => { this.showEq = true }, 200)
    */
    }
  },
  computed: {
    ...mapGetters(['get_dialogMain'])
  },
  watch: {
    model (obj) {
      this.tab = 0
      this.seguimientos = this.model.seguimientos
    }
  }
}
</script>
<style>
</style>
